import moment from 'moment'

export const isValidDate = (value: Date | null) => {
  const dateCheck1 = moment(value, 'MM/DD/YYYY', true).isValid()
  const dateCheck2 = moment(value, 'MM-DD-YYYY', true).isValid()
  const dateCheck3 = moment(value, moment.ISO_8601, true).isValid()

  return dateCheck1 || dateCheck2 || dateCheck3
}
